module.exports = __webpack_public_path__ + "img/9-min.d1c56782.jpg";